import { mapActions, mapGetters, mapMutations } from 'vuex'
import dialogView from './dialog-view/index.vue'

export default {
  name: 'setting-course-categories',
  data () {
    return {
      page: 1,
      showRemoveDialog: false,
      removingItem: null,
    }
  },
  components: {
    dialogView
  },
  computed: {
    ...mapGetters({
      list: 'settingCourseCategories/list',
      limit: 'settingCourseCategories/limit',
      listLength: 'settingCourseCategories/listLength',
      isLoading: 'settingCourseCategories/isLoading',
      isListLoading: 'settingCourseCategories/isListLoading',
      openDialogView: 'settingCourseCategories/openDialogView',

      checkList: 'settingCourseCategories/checkList'
    }),
    headers () {
      return [
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Slug',
          value: 'slug'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        }
      ]
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    ...mapActions({
      fetchList: 'settingCourseCategories/GET_LIST',
      fetchBasicLocales: 'setting/GET_BASIC_LOCALES',
      remove: 'settingCourseCategories/DELETE',
      checkItemInCourses: 'settingCourseCategories/CHECK_ITEM_IN_COURSES',
    }),
    ...mapMutations({
      changeSkip: 'settingCourseCategories/CHANGE_SKIP',
      changeDialogView: 'settingCourseCategories/CHANGE_DIALOG_VIEW',
      setList: 'settingCourseCategories/SET_LIST',
      changeEditId: 'settingCourseCategories/CHANGE_EDIT_ID',
      resetCheckList: 'settingCourseCategories/RESET_CHECK_LIST'
    }),
    changePagination (index) {
      this.changeSkip(this.limit * (index - 1))
      this.$vuetify.goTo(0)
      this.fetchList()
    },
    changeDialog (status = false, item = null) {
      this.changeEditId(item.id)
      this.changeDialogView(status)
    },
    removeCategory () {
      this.remove(this.removingItem).then(() => {
        this.showRemoveDialog = false
        this.$toasted.success(this.$t('success_deleted'))
      })
    },

    changeDialogDeleteItem (item, e) {
        let $btn = e.currentTarget;

        this.isLoadingCheckItem = true;
        $btn.classList.add('has-disabled');

        this.resetCheckList();

        this.checkItemInCourses(item.id).then(() => {
            $btn.classList.remove('has-disabled');
            this.isLoadingCheckItem = false;

            this.showRemoveDialog = true;
            this.removingItem = item;
        })
    }
  },
  destroyed () {
    this.setList([])
  }
}
